import PropTypes from 'prop-types';

const NavItem = ({ children }) => <li>{children}</li>;

NavItem.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NavItem;
